<tasks>
    <div class="bg-white rounded-lg p-8 mt-5">
        <div class="flex justify-between">
            <h2 class="text-2xl/8 font-bold text-custom sm:truncate sm:text-3xl sm:tracking-tight">I tuoi task</h2>
            <div class="filters">
                <form class="flex gap-4 items-center" method="POST" onsubmit="{
                            filter
                        }">
                    <combobox label="" ckey="filtro_societa" placeholder="Filtra per società..."></combobox>
                    <combobox label="" ckey="filtro_stato_task" placeholder="Filtra per stato task..."></combobox>
                    <input-text ckey="search_text" placeholder="Cerca..."></input-text>
                    <my-button type="submit" is_square="1">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                        </svg>
                    </my-button>
                </form>
            </div>
        </div>
        <generic-table 
            ckey="{ KEYS.TASK }" 
            columns="{ state.columns }"
            rows="{ state.rows }"
            total_rows="{ state.total_rows }"
            page_size="{ state.page_size }"
            current_page="{ state.current_page }"
            condensed="1" 
            >
            <button-group
                slot="actions"
                ckey="{ KEYS.TASK }"
                row="{ row }"
                options="{}"
                ></button-group>
        </generic-table>
    </div>
    
    <script>
        import StoreService from '/src/services/store'
        import eventBus from '/src/utils/event-bus'
        import { fetchComboboxStatiTask, fetchComboboxSocieta } from '/src/utils/functions'
        import moment from 'moment-with-locales-es6'
        import { CONFIG, EVENTS, KEYS, ACTIONS } from '/src/utils/constants'

        export default {

            ACTIONS: ACTIONS,
            KEYS: KEYS,

            onBeforeMount(props, state) {
                this.state = {
                    columns: [
                        {type: CONFIG.TEXT, label: 'Commessa n°', field: 'numero', is_sortable: true, is_link: true, link_prefix: '#/commesse', key_field: 'id_commessa'},
                        {type: CONFIG.TEXT, label: 'Stato della commessa', field: 'stato_commessa', is_sortable: true},
                        {type: CONFIG.TEXT, label: 'Cliente', field: 'cliente', is_sortable: true},
                        {type: CONFIG.TEXT, label: 'Società', field: 'societa', is_sortable: true},                      
                        {type: CONFIG.DATE, label: 'Data', field: 'data', is_sortable: true},
                        {type: CONFIG.TEXT, label: 'Descrizione', field: 'descrizione', is_wrappable: true},
                        {type: CONFIG.TEXT, label: 'Note', field: 'note', is_wrappable: true},
                        {type: CONFIG.TEXT, label: 'Risorsa', field: 'risorsa'},
                        {type: CONFIG.DATE, label: 'Data inizio', field: 'data_inizio', is_sortable: true},
                        {type: CONFIG.DATE, label: 'Data fine', field: 'data_fine', is_sortable: true},
                        {type: CONFIG.TEXT, label: 'Stato del task', field: 'stato', is_sortable: true}
                    ],
                    rows: [],
                    total_rows: 0,
                    current_page: 1,
                    page_size: CONFIG.N_ITEMS,
                    sort_column: 'numero',
                    sort_direction: 'desc',
                    search_stato: '',
                    search_societa: '',
                    search_text: '',
                }
                //eventBus.on(EVENTS.COMBOBOX.SELECTED, this.handleComboboxSelected)
                eventBus.on(EVENTS.UI.CHANGE_PAGE, this.handlePageChange)
                eventBus.on(EVENTS.UI.SORTING_CHANGE, this.handleSortChange)
                eventBus.on(EVENTS.UI.CLICK_BUTTON_GROUP, this.handleClickAction)
                eventBus.on(EVENTS.ITEMS.REFRESH, this.handleRefresh)
            },

            async onMounted(props, state) {
                fetchComboboxStatiTask().then(stati => {
                    eventBus.trigger(EVENTS.COMBOBOX.UPDATE, {
                        ckey: 'filtro_stato_task',
                        items: stati
                    });
                });

                fetchComboboxSocieta().then(societa => {
                    eventBus.trigger(EVENTS.COMBOBOX.UPDATE, {
                        ckey: 'filtro_societa',
                        items: societa
                    });
                });
                this.fetchData()
            },

            onBeforeUnmount(props, state) {
                //eventBus.off(EVENTS.COMBOBOX.SELECTED, this.handleComboboxSelected)
                eventBus.off(EVENTS.UI.CHANGE_PAGE, this.handlePageChange)
                eventBus.off(EVENTS.UI.SORTING_CHANGE, this.handleSortChange)
                eventBus.off(EVENTS.UI.CLICK_BUTTON_GROUP, this.handleClickAction)
                eventBus.off(EVENTS.ITEMS.REFRESH, this.handleRefresh)
            },

            handleRefresh(e) {
                if (e.ckey === KEYS.TASK) {
                    this.fetchData();
                }
            },

            handlePageChange(e) {
                if (e.ckey === KEYS.TASK) {
                    this.update({current_page: e.page});
                    this.fetchData();
                }
            },

            handleSortChange(e) {
                if (e.ckey === KEYS.TASK) {
                    this.update({
                        sort_column: e.column,
                        sort_direction: e.direction,
                        current_page: 1 // Torna alla prima pagina
                    });
                    this.fetchData();
                }
            },

            async fetchData() {
                const {sort_column, sort_direction, current_page, search_risorsa, search_stato, search_societa, search_text} = this.state;
                const where = {};
                if (search_stato) {
                    where.stato = search_stato
                }
                if (search_societa) {
                    where.societa = search_societa
                }
                const result = await StoreService.fetchTask(
                        sort_column,
                        sort_direction,
                        current_page,
                        search_text,
                        where
                        );
                if (result.items) {
                    this.update({
                        rows: result.items,
                        total_rows: result.total
                    })
                    eventBus.trigger(EVENTS.ITEMS.CHANGED, {
                        ckey: KEYS.TASK,
                        items: {
                            count: this.state.total_rows,
                            results: this.state.rows
                        },
                        page: this.state.current_page
                    })
                } else {
                    console.error('Errore nel caricamento dei dati:', result.error)
                }
            },

            filter(e) {
                e.preventDefault(); // Evita il refresh della pagina
                const filtroStato = document.getElementById('filtro_stato')?.value || '';
                const filtroSocieta = document.getElementById('filtro_societa')?.value || '';
                const searchText = document.getElementById('search_text')?.value || '';
                // Aggiorna lo stato con i filtri attivi
                this.update({
                    search_stato: filtroStato,
                    search_societa: filtroSocieta,
                    search_text: searchText,
                    current_page: 1 // Reset alla prima pagina
                });
                // Effettua una nuova query
                this.fetchData();
            }
        }

    </script>
</tasks>
